import React, { forwardRef } from "react";

const InputOTP = forwardRef(({ index, onChange, onKeyDown }, ref) => {
  const handleInput = (e) => {
    e.target.value = e.target.value.replace(/\D/g, "");
  };

  return (
    <input
      ref={ref}
      type="text"
      maxLength="1"
      inputMode="numeric"
      pattern="[0-9]*"
      className="w-12 h-14 text-center text-lg font-semibold border border-[#D9D9D9] rounded-lg bg-[#EDEDED] focus:outline-none focus:ring-2 focus:ring-[#F59581]"
      onChange={(e) => onChange(e, index)}
      onKeyDown={(e) => onKeyDown(e, index)}
      onInput={handleInput}
    />
  );
});

export default InputOTP;
